import React, { useEffect } from 'react';

function MainPage({ symptoms, onSymptomSelect }) {
  const userName = sessionStorage.getItem('herbalzen_user_name');

  // Check for URL parameter to auto-select symptom
  const params = new URLSearchParams(window.location.search);
  const symptomId = params.get('symptom');
  const targetSymptom = symptomId ? symptoms.find(s => s.id === symptomId) : null;

  useEffect(() => {
    if (targetSymptom) {
      // Clear the parameter so the user can navigate back to the menu
      const url = new URL(window.location.href);
      url.searchParams.delete('symptom');
      window.history.replaceState({}, '', url.toString());
      onSymptomSelect(targetSymptom);
    }
  }, [targetSymptom, onSymptomSelect]);

  if (targetSymptom) return null;

  return (
    <div>
      <div className="header">
        <h1>🍵 {userName ? `Welcome, ${userName}` : 'Tealybox Wellness Concierge'}</h1>
        <p>Personalized for your body, tailored to your needs</p>
      </div>
      <div className="symptom-grid">
        {symptoms.map(symptom => (
          <div
            key={symptom.id}
            className={`symptom-card ${!symptom.enabled ? 'disabled' : ''}`}
            onClick={() => onSymptomSelect(symptom)}
          >
            <div className="symptom-icon">{symptom.icon}</div>
            <div className="symptom-title">{symptom.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MainPage;
